// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e8096a96","453":"6901a6fd","455":"629c1581"}[chunkId] + ".chunk.js";
};